// src/documents/closingTemplate.js
//
// Mapa de campos del Closing Statement sobre la plantilla
// src/assets/documents/closing-template.pdf (Adjustify, con membrete; el
// cliente la entregó 2026-09-30). La plantilla ya trae el membrete, los
// rótulos, las rayas, el nombre del pagador (PAYER_PRINTED) y el ancla de
// DocuSign `/csr_payer_sign/`: aquí solo se escriben los datos.
//
// Las posiciones de la página 1 son las del Closing anterior (que se dibujaba
// desde cero): el cliente pidió que los datos queden donde estaban. Coinciden
// con los rótulos de la plantilla. Se dan como LÍNEA BASE medida desde arriba
// (y = 0 arriba); `value` la convierte a la "raya" que espera pdfFill.js.
// Las de la página 2 (espacios en blanco dentro del texto) salen de las
// coordenadas de la plantilla: cada una es la raya o el guion bajo del hueco.
import { BASELINE_OFFSET } from './pdfFill';
import { CLOSING_FEES } from './closingData';

const VALUE_X = 387;
const AMOUNT_WIDTH = 150;

// x/y = donde empieza el texto y su línea base (como en el diseño anterior).
// Los datos van en negro, como antes (`plain`).
const value = (key, { page = 0, x, baseline, width, size = 9, align }) => ({
  key, page, x: x - 1, y: baseline + BASELINE_OFFSET, width, size, plain: true, ...(align && { align })
});

export const CLOSING_TEMPLATE = {
  // La plantilla trae impreso "10%" junto a "Public Adjuster Fee": el % real
  // del reclamo se escribe encima (feePercent), así que se tapa el fijo.
  patches: [{ page: 0, x: 220.5, y: 349, width: 28, height: 14 }],
  fields: [
    // ── Página 1: breakdown ───────────────────────────────────────────────
    value('insureds', { x: 176, baseline: 158, width: 380 }),
    value('claimNumber', { x: 176, baseline: 183, width: 380 }),
    value('policyNumber', { x: 176, baseline: 208, width: 380 }),
    value('insuranceCompany', { x: 176, baseline: 233, width: 380 }),
    value('checkAmount', { x: VALUE_X, baseline: 310, width: AMOUNT_WIDTH }),
    value('feePercent', { x: 222, baseline: 360, width: 50, size: 11 }),
    value('paFee', { x: VALUE_X, baseline: 360, width: AMOUNT_WIDTH }),
    ...CLOSING_FEES.map((fee, i) => value(fee.key, { x: VALUE_X, baseline: 385 + i * 25.3, width: AMOUNT_WIDTH })),
    value('netToClient', { x: VALUE_X, baseline: 612, width: AMOUNT_WIDTH }),

    // ── Página 2: aceptación y firmas ─────────────────────────────────────
    // "I (We) ______ , read the above ... amount of $ ______ ,"
    value('insureds', { page: 1, x: 81.67, baseline: 190, width: 137.15 }),
    value('netPlain', { page: 1, x: 508.57, baseline: 190, width: 44.81 }),
    // "as a Coverage ______ of the above captioned claim against ______ ."
    value('paymentType', { page: 1, x: 124.04, baseline: 205, width: 55.04 }),
    value('insuranceCompany', { page: 1, x: 362.3, baseline: 205, width: 118.73 }),
    // "Witness my signature, this ______ (date)."
    value('date', { page: 1, x: 180.1, baseline: 435, width: 50.93 }),
    // Debajo de la raya del asegurado (Payee); el del Payer ya viene impreso.
    value('insureds', { page: 1, x: 276, baseline: 510, width: 174, size: 11 })
  ]
};
